import {makeAutoObservable} from "mobx";
import {api, catchApi} from "../../api";
import {CustomerProjectionDto} from "../../api/sca";

export interface ScaCustomerItem {
    label: string
    customerNumber: string
    id: string
}

const serviceApi = api.sca.api

function buildScaCustomerItem(item: CustomerProjectionDto): ScaCustomerItem {
    return {
        label: `${item.name}${item.displayName ? ` [${item.displayName}]` : ''} (${item.customerNumber})`,
        customerNumber: `${item.customerNumber}`,
        id: `${item.customerId}`
    }
}

class ScaCustomerStore {
    get items(): ScaCustomerItem[] {
        return this._items;
    }

    set items(value: ScaCustomerItem[]) {
        this._items = value;
    }

    private _items: ScaCustomerItem[] = []

    constructor() {
        makeAutoObservable(this)
    }

    async search(query: string): Promise<ScaCustomerItem[]> {
        const response = await catchApi(async () => serviceApi.findCustomers({query: query}))
        return (response?.data || []).map(item => buildScaCustomerItem(item))
    }

    async init() {
        const response = await catchApi(async () => serviceApi.findCustomers())
        if (response && response.data) {
            this.items = (response.data || []).map(item => ({
                label: `${item.name}${item.displayName ? ` [${item.displayName}]` : ''} (${item.customerNumber})`,
                customerNumber: `${item.customerNumber}`,
                id: `${item.customerId}`
            }))
        }
    }
}

const scaCustomerStore = new ScaCustomerStore()

export {
    scaCustomerStore,
    buildScaCustomerItem,
}
